import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Calendar, Shield } from 'lucide-react';
import { formatDateShort, resolveBadgeUrl, getVenueAbbrev } from './utils';

export const UpcomingMatchesWidget = ({ stats, user, opponentBadgeMap = {} }) => {
  const showOpponentBadges = user?.show_opponent_badges !== false;

  return (
    <div className="h-full" data-testid="upcoming-matches">
      <div className="flex flex-row items-center justify-between pb-4">
        <h3 className="text-xl font-semibold font-title">Fixtures</h3>
        <Link to="/matches">
          <Button variant="ghost" size="sm" style={{ color: user?.menu_color || '#059669' }} className="hover:opacity-80">
            View All
          </Button>
        </Link>
      </div>
      <div>
        {stats?.upcoming_matches?.length > 0 ? (
          <div className="flex flex-col gap-3">
            {stats.upcoming_matches.slice(0, 3).map((match) => {
              const venueAbbrev = getVenueAbbrev(match.venue);
              const opponentBadge = resolveBadgeUrl(opponentBadgeMap[(match.opponent || '').toLowerCase().trim()]);
              return (
                <div
                  key={match.id}
                  className="flex items-center gap-3 p-3 bg-white rounded-xl"
                  style={{ border: '1px solid #e5e2dc' }}
                  data-testid={`upcoming-match-${match.id}`}
                >
                  {showOpponentBadges && (
                    opponentBadge ? (
                      <img
                        src={opponentBadge}
                        alt={`${match.opponent} badge`}
                        className="w-10 h-10 object-contain shrink-0"
                      />
                    ) : (
                      <div className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center shrink-0">
                        <Shield className="w-5 h-5 text-gray-300" strokeWidth={1.5} />
                      </div>
                    )
                  )}
                  <div className="flex-1 min-w-0 overflow-hidden">
                    <p className="font-bold text-gray-900 truncate leading-tight">{match.opponent}</p>
                    <p className="text-gray-500 truncate mt-0.5" style={{ fontSize: '0.7rem' }}>
                      {match.competition ? `${match.competition} (${venueAbbrev})` : `(${venueAbbrev})`}
                    </p>
                  </div>
                  <div className="text-right shrink-0">
                    <p className="text-gray-900 whitespace-nowrap" style={{ fontSize: '0.75rem', fontWeight: 600 }}>
                      {formatDateShort(match.date)}
                    </p>
                    <p className="text-xs text-gray-400 mt-0.5">{match.kick_off_time || '--:--'}</p>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-400">
            <Calendar className="w-10 h-10 mx-auto mb-2 opacity-50" strokeWidth={1.5} />
            <p>No upcoming matches</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpcomingMatchesWidget;
